import { render, staticRenderFns } from "./UnfittedOrdersReport.vue?vue&type=template&id=318e3cdc&"
import script from "./UnfittedOrdersReport.vue?vue&type=script&lang=js&"
export * from "./UnfittedOrdersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports